import "./webgl";
import "./style.css";
import '@fontsource/instrument-serif';
